module.exports = __webpack_public_path__ + "static/media/ev3.c42ebe35.jpg";